import * as moment from "moment";
import { IPageModel } from "./page.model";


export interface IPermissionModel {
  id?: number;
  name: string;
  code: string;
  page_id: number;
  page?: IPageModel;
  is_enabled: boolean;
  permission_added?: boolean;
  start_date: moment.Moment;
  end_date?: moment.Moment;
  created?: moment.Moment;
  modified?: moment.Moment;
}

export interface IResultPermissionModel {
  count: number;
  next: string;
  previous: string;
  results: IPermissionModel[];
}

export class PermissionModel {

  id?: number;
  name: string;
  code: string;
  pageId: number;
  page?: IPageModel;
  isEnabled: boolean;
  startDate: moment.Moment;
  endDate?: moment.Moment;
  created?: moment.Moment;
  modified?: moment.Moment;
  permissionAdded?: boolean = false;

  constructor() {
    this.isEnabled = true;
    this.permissionAdded = false;
  }

  static fromObject(permission: IPermissionModel): PermissionModel {
    let obj = new PermissionModel();
    obj.id = permission.id;
    obj.name = permission.name;
    obj.pageId = permission.page_id;
    obj.isEnabled = permission.is_enabled;
    obj.startDate = moment(permission.start_date);
    obj.endDate = (permission.end_date) ? moment(permission.end_date) : permission.end_date;
    if (permission.permission_added !== undefined){
      obj.permissionAdded = permission.permission_added;
    }
    obj.created = moment(permission.created);
    obj.modified = moment(permission.modified);
    return obj;
  }

  static fromObjectArray(permissions: IPermissionModel[]): PermissionModel[] {
    return permissions.map((permission: IPermissionModel) => PermissionModel.fromObject(permission));
  }
}

export class ResultPermissionModel {
  count: number = 0;
  next: string;
  previous: string;
  results: PermissionModel[] = [];

  static fromObject(result: IResultPermissionModel): ResultPermissionModel {
    let obj = new ResultPermissionModel();
    obj.count = result.count | 0;
    obj.next = result.next;
    obj.previous = result.previous;
    obj.results = (result.results && result.results.length > 0) ? PermissionModel.fromObjectArray(result.results) : [];
    return obj;
  }
}
